import React, { FC, useState, useEffect, useRef } from "react";
import i18n from 'i18next';
import { useTranslation } from "react-i18next";
import Select from "shared/Select/Select";
import Input from "shared/Input/Input";
import { getPureArray } from "utils/util";
import { commonAxiosPostRequest } from "utils/request";

type IRegionInfo = {
    province: string;
    city: string;
    area?: string;
    address: string;
};
export interface ComponentProps {
    /* 订单总价 */
    regionInfo: IRegionInfo;
    onChange: (value: IRegionInfo, type: 'province' | 'city' | 'address') => void;
};

type TOption = {
    value: string;
    label: string;
    children?: TOption[];
};

const ShippingAddress: FC<ComponentProps> = (props) => {
    const { t } = useTranslation();
    const { language } = i18n;
    const { regionInfo, onChange } = props;
    const regionInfoRef = useRef(regionInfo);
    regionInfoRef.current = regionInfo;
    // 省列表
    const [provinceList, setProvinceList] = useState<TOption[]>([]);
    // 市列表
    const [cityList, setCityList] = useState<TOption[]>([]);

    const onProvinceChange = (e: any) => {
        const { value } = e.target;
        const currentCityList = provinceList.find(item => item.value === value)?.children || [];
        setCityList(currentCityList);
        onChange({
            ...regionInfo,
            province: value,
            city: currentCityList[0]?.value || '',
        }, 'province');
    };

    const onCityChange = (e: any) => {
        const { value } = e.target;
        onChange({ ...regionInfo, city: value }, 'city');
    };

    const onAreaChange = (e: any) => {
        const { value } = e.target;
    };

    const onAddressChange = (e: any) => {
        const { value } = e.target;
        onChange({ ...regionInfo, address: value }, 'address');
    }

    const handleQueryRegionList = async () => {
        const [error, response] = await commonAxiosPostRequest<{ list: TOption[] }, {}>('/universal_mall/api/app/common/region', { language });
        const list = getPureArray<TOption>(response?.list);
        setProvinceList(list);
    }

    useEffect(() => {
        handleQueryRegionList();
    }, []);

    useEffect(() => {
        if (provinceList.length === 0) {
            return;
        }
        const latestRegionInfo = regionInfoRef.current;
        const provinceValue = latestRegionInfo.province || provinceList[0].value;
        const currentCityList = provinceList.find(item => item.value === provinceValue)?.children || [];
        setCityList(currentCityList);
        const hasProvince = Boolean(latestRegionInfo.province);
        const hasCity = Boolean(latestRegionInfo.city);
        const cityStillValid = currentCityList.some(item => item.value === latestRegionInfo.city);
        if (hasProvince && (cityStillValid || hasCity)) {
            return;
        }
        onChange({
            ...latestRegionInfo,
            province: provinceValue,
            city: cityStillValid ? latestRegionInfo.city : (latestRegionInfo.city || currentCityList[0]?.value || ''),
        }, 'province');
    }, [provinceList, regionInfo.province, regionInfo.city]);

    return (
        <>
            <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
                {/* 省 */}
                <Select onChange={onProvinceChange} value={regionInfo.province} placeholder="请选择">
                    <option value={''}>{t('common.select_placeholder')}</option>
                    {provinceList.map((item: TOption) => {
                        return (
                            <option key={item.value} value={item.value}>{item.label}</option>
                        );
                    })}
                </Select>
                {/* 市 */}
                <Select onChange={onCityChange} value={regionInfo.city}>
                    <option value={''}>{t('common.select_placeholder')}</option>
                    {
                        cityList.map((item: TOption) => {
                            return (
                                <option key={item.value} value={item.value}>{item.label}</option>
                            );
                        })
                    }
                </Select>
                {/* 区 */}
                {/* <Select className="mt-1.5" onChange={onAreaChange} value={regionInfo.area}>
                    {
                        cityList.map((item: TOption) => {
                            return (
                                <option defaultValue={item.value} key={item.value}>{item.value}</option>
                            );
                        })
                    }
                </Select> */}
            </div>
            <Input
                name="address"
                value={regionInfo.address}
                onChange={onAddressChange}
                placeholder={t('checkout.address_input_error')}
            />
        </>
    );
};

export default ShippingAddress;